import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { SelectItem } from 'primeng/api';
import { Status } from '../../../actiontracker/model/status.model';
import { ActiontrackerService } from '../../../actiontracker/services/actiontracker.service';
import { PreReqConfiguration, PreRequisites } from '../../../masterscreen/model/pre-requisites.model';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { SearchText } from '../../../observation/model/searchTexts.model';
import { Usertypes } from '../../../observation/model/usertypes.model';
import { ObservationConstantsService } from '../../../observation/services/observation-constants.service';
import { ObservationService } from '../../../observation/services/observation.service';
import { User, UserPermissionParameters } from '../../../shared/models/user.model';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { ConstantsService } from '../../../shared/services/constants.service';
import { HseErrorHandlerService } from '../../../shared/services/hse-error-handler.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { ApprovingAuthorityUser, ContractHolderStatus, Document, MasterRequest, PassRequestLog, PrerequisteConfiguration, Request } from '../../model/masterrequest.model';
import { POBPermissionDetails } from '../../model/POBPermissions.model';
import { PersononboardConstantsService } from '../../services/persononboard-constants.service';
import { PersononboardService } from '../../services/persononboard.service';

import {
  UserLogInActivity
} from "../../../shared/models/user.model";


@Component({
  selector: 'ara-view-pass-request',
  templateUrl: './view-pass-request.component.html',
  styleUrls: ['./view-pass-request.component.css']
})
export class ViewPassRequestComponent implements OnInit {
  @Input()
  LocationName: string;
  @Input()
  LocationId: number;
  @Input()
  CompanyName: string;
  @Input()
  CompanyId: number;
  @Input()
  passTypeRowIdValue: number;
  @Input()
  passTypeRowNameValue: string;
  @Input()
  ContractId: number;
  @Input()
  ContractNumber: string;
  @Output()
  onsubmitEvent = new EventEmitter();
  prerequisite: Document[] = [];
  passRequestForData: MasterRequest;
  passRequestForDataResponse: MasterRequest[] = [];
  passRequestForFormData: Request;
  passRequestForDocument: Document;
  StatusForHSEDocumentResponse: any[] = [];
  StatusForHSEDocument: StatusForHSEDocument;
  display: boolean = true;
  validate: boolean = true;
  isInactiveLocation: boolean = false;
  isIncidentReportErrorMsg: boolean = false;
  PrerequisitDetailsRequest: PreRequisites;
  prerequisiteDetailsResponse: PreRequisites[] = [];
  preRequisitesConfiguration: PreReqConfiguration;
  onPageLoad: boolean = true;
  gstatus: boolean = false;
  attachmentLinkEnabled: boolean;
  IsExpireyDateNeededEnabled: boolean;
  PrerequisiteIds: any[] = [];
  PrerequisiteName: string;
  routesFlag: { routeName: string, routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string, routeURL: string; isClickable: boolean; }[];
  alertType: any;
  successDetails: string;
  errorDetails: any;
  POBPermission: POBPermissionDetails;
  userPermissions: UserPermissionParameters;
  loggedInUserJSON: any;
  disablePOB: boolean = false;
  accept: string;
  multiple: boolean;
  confirmMessage: any;
  status: Status;
  preReqConfiguration: PrerequisteConfiguration;
  preReqConfigurationRequest: PrerequisteConfiguration[] = [];
  @Output() OnChangeEvent: EventEmitter<any>;
  observationFor: string;
  userTypes: Usertypes[] = [];
  searchTexts: SearchText;
  user: User;
  userResults: User[] = [];
  selectedUserEmp;
  @Input() isBackOfficeViewDetailsPage: any;
  approvingAuthority: User;
  SaveAndContinueResponse: Request[] = [];
  errorMsgForRangeDate: boolean = false;
  passRequestLogInfo: PassRequestLog;
  approvingAuthorityUserData: ApprovingAuthorityUser;
  passrequestId: number;
  sub: any;
  tempFiles: any[];
  PhotoURL: string;
  UserName: string;
  FromDate: Date;
  ExpiryDate: Date;
  PassType: any;
  QRCode: string;
  PassRequestId: number;
  passRequestLogs: any[];
  isBlocked: string;
  contractHolderStatusData: ContractHolderStatus;
  pobStatus: { StatusId: number; StatusName: string; }[];
  isShowAccept: boolean = false;
  isApprovingAuthority: boolean;
  isApprovingAuthorityMsg: boolean;
  isPersonNameMsg: boolean;
  isPersonCompanyMsg: boolean;
  isIdMsg: boolean;
  isFromDateMsg: boolean;
  isToDateMsg: boolean;
  isValidityDateMsg: boolean;
  isEmailIdMsg: boolean;
  isJobDescpMsg: boolean;
  isDesignationMsg: boolean;
  isDepartmentMsg: boolean;
  isRemarksMsg: boolean;
  showAck: string;
  minDate: Date;
  isValidData: boolean;
  validateFileAttachment: boolean = false;
  UnitId: number;
  UnitName: string;
  prerequisitesDate: any;
  passId: any;
  passRequestStatus: any;
  statusDetails: SelectItem[];
  validateApproval: boolean;
  allApproved :boolean = false;
  showErrormsg: boolean;
  isNext: boolean = true;
  isPrevious: boolean = true;
  passIndex: number = -1;
  passIds: any;
  maxPassDate: Date;
  currentDate: Date = new Date();
  passPhoto: any[] = [];
  moduleId: number;
  categoryData: any;
  specificationDetailsData: any;
  approvaldata: any;
  isBlockedRemarks: boolean;
  ContractHolderId: number;
  SecurityCoordinatorId: number;
  downloadPrintDialog: boolean = false;
  currentApproval: any;
  independentPermissions: any;
  isQualifiedForRenew: boolean = false;
  POBApprovalDisable: boolean = false;
  isActive: boolean = false;
  UserId:number = 0;//Pritesh
  //BOC Pritesh
  dialogHeight: string;
  dialogWidth: string;
  ReportUserId : number;
  ReportModule : string;
  ReportRecordId : number;
  ReportProcessId : number = 0;
  ReportclosePopup: boolean = false;
  showRecreatebtn: boolean = true;
  isUpdateAllowed: boolean = false;
  //EOC Pritesh

  updateActionTrack: any[];
  retVal: boolean;
  userActivityList: UserLogInActivity[] = [];
  url: any;
  url1: any;

  constructor(private ref: ChangeDetectorRef, private hseErrorHandler: HseErrorHandlerService, private activateRoute: ActivatedRoute,
    private masterscreenService: MasterscreenService, private pobServices: PersononboardService,
    private baseService: BaseService, private observationService: ObservationService,
    private commonService: CommonService, private router: Router, private pobService: ActiontrackerService,
    private route: ActivatedRoute, private notificationsService: NotificationsService, private translate: TranslateService) {
    this.preRequisitesConfiguration = new PreReqConfiguration();
    this.POBPermission = new POBPermissionDetails();
    this.userPermissions = new UserPermissionParameters();
    this.passRequestForData = new MasterRequest();
    this.passRequestForFormData = new Request();
    this.passRequestForDocument = new Document();
    this.accept = '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF';
    this.multiple = true;
    // this.passRequestLogInfo = new PassRequestLog();
    this.OnChangeEvent = new EventEmitter();
    this.sub = this.route.params.subscribe(params => {
      this.passrequestId = +params['passId'];
    });
    this.approvingAuthorityUserData = new ApprovingAuthorityUser();
    this.passRequestLogs = [];
    this.contractHolderStatusData = new ContractHolderStatus();
    this.prerequisitesDate = [];
    this.moduleId = ConstantsService.PermissionMatrixModules.POB;

  }
 async ngOnInit() {
    if (this.isBackOfficeViewDetailsPage) {
      this.observationFor = ObservationConstantsService.ObservationCardModuleConst.observationOnBehalfEmployee;
      // this.setObservationForEdit(ObservationConstantsService.ObservationCardModuleConst.observationOnBehalfEmployee);
    } else {
      // auto-checked radio button
      this.observationFor = ObservationConstantsService.ObservationCardModuleConst.observationFor;
    }
    this.showAck = this.activateRoute.snapshot.params['showAck'];
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    const routes = JSON.stringify(PersononboardConstantsService.PersonOnBoardUrl.InnerRoutes);
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = PersononboardConstantsService.PersonOnBoardUrl.ReportRoutes;
    this.searchTexts = new SearchText();
    this.user = new User();
    
    this.independentPermissions = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    if(this.independentPermissions ==null)
    {
      this.commonService.getUserIndependentPermissions(this.loggedInUserJSON.UserId);
      console.log('await');
      await new Promise(f => setTimeout(f, 1000));
      this.independentPermissions = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
      console.log(this.independentPermissions);
    }

   
    this.getHSEDocument();
    this.checkPassRequestRaised(this);
    this.getHSECheckDocuments();
    this.getPrerequisiteConfiguration();
    this.getUserTypes();
    this.isBlocked = 'false';

    this.minDate = new Date();
    if (this.passrequestId > 0) {
      this.getPassRequestByPassrequestId();
    }
    this.pobStatus = PersononboardConstantsService.POBStatus.Status;
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }

  dateValidation() {
    if (this.passRequestForFormData.PassRequestFromDate < this.passRequestForFormData.PassRequestToDate) {
      this.errorMsgForRangeDate = false;
    } else {
      this.errorMsgForRangeDate = true;
    }
  }
  getPermissionDetails() {
    this.userPermissions.ModuleId = ConstantsService.PermissionMatrixModules.POB;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = this.passRequestForData.MasterUnitId;
    const apiRequest = {
      Model: this.userPermissions
    };
    this.commonService.getPermissionDetailsForUser(apiRequest, this.callbackMethodForgetPermissionDetails.bind(this));
  }
  callbackMethodForgetPermissionDetails(response) {
    const permissions = response.Result;
    if (response.Result) {
      this.POBPermission = permissions.POBPermission;
      this.POBPermission.POB_Own = this.passRequestForFormData.CreatedBy == this.loggedInUserJSON.UserId ? true : false;
      if (
        !this.POBPermission.POB_Contractor_Add &&
        !this.POBPermission.POB_Contractor_Add_Unit &&
        !this.POBPermission.POB_Staff_Add &&
        !this.POBPermission.POB_Staff_Add_Unit &&
        !this.POBPermission.POB_Admin &&
        !this.POBPermission.POB_Admin_Unit
      ) {
        this.routesFlag.find(s => s.routeName == "New Pass").isClickable = false;
      }
      if (!this.POBPermission.POB_Admin && !this.POBPermission.POB_Admin_Unit) {
        this.disablePOB = true;
      }
      if(!this.POBPermission.POB_Contractor_Add &&
        !this.POBPermission.POB_Contractor_Add_Unit &&
        !this.POBPermission.POB_Staff_Add &&
        !this.POBPermission.POB_Staff_Add_Unit && !this.POBPermission.POB_Admin && !this.POBPermission.POB_Admin_Unit){
      this.isUpdateAllowed = false;
      }
      else{
        this.isUpdateAllowed = true;
      }
      if (this.passId > 0 && this.passRequestForFormData.PassRequestToDate < new Date(moment.now()) && (this.POBPermission.POB_Admin || this.POBPermission.POB_Admin_Unit)) {
        this.isQualifiedForRenew = true;
      }
      if (this.POBPermission.POB_Own &&
        (this.POBPermission.POB_Staff_Add || this.POBPermission.POB_Staff_Add_Unit) &&
         this.passRequestForFormData.PassStatusName == "Pending For Approval" &&
         this.passRequestForFormData.ApprovalStatus == "Pending for Approval" &&
         this.passRequestForFormData.DocumentStatus == "Pending for Approval" &&
         this.passRequestForData.PassTypeId == 1)
      {
         this.disablePOB = false;
         this.POBApprovalDisable = true;
      }
      if (this.POBPermission.POB_Own &&
        (this.POBPermission.POB_Contractor_Add || this.POBPermission.POB_Contractor_Add_Unit) &&
         this.passRequestForFormData.PassStatusName == "Pending For Approval" &&
         this.passRequestForFormData.ApprovalStatus == "Pending for Approval" &&
         this.passRequestForFormData.DocumentStatus == "Pending for Approval" &&
         this.passRequestForData.PassTypeId == 2)
      {
         this.disablePOB = false;
         this.POBApprovalDisable = true;
      }
    }
    this.passRequestForFormData.PassTypeName = this.passTypeRowNameValue;
    this.pobServices.setUpdatedData(
      JSON.stringify(this.passRequestForFormData),
      "UpdateAction"
    );

   
  }
  checkPassRequestRaised(data) {
    this.passId = data.passRequestForData.PassRequestId;
    this.UnitId = data.passRequestForData.UnitId;
    this.retriveListOfPrerequisiteConfigurationMapping(data);
  }

  SaveorUpdatePassRequest() {
    this.baseService.closePopup = false;
    this.checkValidation();
    this.onsubmitEvent.emit('data');
    if (this.validate) {
      this.passRequestForData.MasterUnitId = this.UnitId;
      this.passRequestForData.MasterCompanyId = this.CompanyId;
      this.passRequestForData.MasterLocationId = this.LocationId;
      this.preReqConfigurationRequest.forEach(element => {
        if (element.UnitId === this.passRequestForData.MasterUnitId && element.LocationId === this.passRequestForData.MasterLocationId && element.PassTypeId === this.passRequestForData.PassTypeId) {
          this.passRequestForData.PreRequisiteConfigurationId = element.PreRequisiteConfigurationId;
        }
      });
      this.passRequestForFormData.PassTypeName = this.passTypeRowNameValue;
      this.passRequestForData.RaisedBy = this.loggedInUserJSON.UserId;
      this.passRequestForFormData.PrerequisiteDocuments = this.prerequisite;
      if (this.isBlocked === 'true') {
        this.passRequestForFormData.Blocked = true;
      } else {
        this.passRequestForFormData.Blocked = false;
      }
      this.passRequestForFormData.PassRequestFromDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestFromDate);
      this.passRequestForFormData.PassRequestToDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestToDate);
      this.passRequestForFormData.ValidityDate = this.adjustForTimezone(this.passRequestForFormData.ValidityDate);
      this.SaveAndContinueResponse.push(this.passRequestForFormData);
      this.passRequestForData.Requests = this.SaveAndContinueResponse;
      const apiRequest = {
        Model: this.passRequestForData,
      };
      this.pobServices.SaveorUpdatePassRequest(apiRequest, this.callbackMethodForSavePassRequestFormData.bind(this));
    }
  }
  updatePassRequest() {
    this.baseService.closePopup = false;
    this.checkValidation();
    if (this.validate) {
      this.baseService.showRootLoader = true;
      this.onsubmitEvent.emit('data');
      this.passRequestForData.MasterCompanyId = this.CompanyId;
      this.passRequestForData.MasterUnitId = this.UnitId;
      this.passRequestForData.MasterLocationId = this.LocationId;
      this.preReqConfigurationRequest.forEach(element => {
        if (element.UnitId === this.passRequestForData.MasterUnitId && element.LocationId === this.passRequestForData.MasterLocationId && element.PassTypeId === this.passRequestForData.PassTypeId) {
          this.passRequestForData.PreRequisiteConfigurationId = element.PreRequisiteConfigurationId;
        }
      });
      this.passRequestForFormData.PassTypeName = this.passTypeRowNameValue;
      this.passRequestForData.RaisedBy = this.loggedInUserJSON.UserId;
      this.passRequestForData.PassRequestId = this.passrequestId;
      this.passRequestForFormData.PrerequisiteDocuments = this.prerequisite;
      if (this.isBlocked === 'true') {
        this.passRequestForFormData.Blocked = true;
      } else {
        this.passRequestForFormData.Blocked = false;
      }
      this.passRequestForFormData.PassRequestFromDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestFromDate);
      this.passRequestForFormData.PassRequestToDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestToDate);
      this.passRequestForFormData.ExpiryDate = this.adjustForTimezone(this.passRequestForFormData.ExpiryDate);
      this.SaveAndContinueResponse.push(this.passRequestForFormData);
      this.passRequestForData.Requests = this.SaveAndContinueResponse;
      this.passRequestForData.UnitId = this.UnitId;
      this.passRequestForData.CompanyId = this.CompanyId;
      this.passRequestForData.LocationId = this.LocationId;
      this.passRequestForData.PassTypeId = this.passTypeRowIdValue;
      this.passRequestForData.IsDraft=false;
      
      if (this.categoryData && this.categoryData.length > 0) {
        this.submitSpecificationData();
      }
      const apiRequest = {
        Model: this.passRequestForData
      };
      this.updateActionTrack = JSON.parse(
        this.pobServices.getUpdatedData("UpdateAction")
      );
      this.pobServices.UpdatePassRequest(apiRequest, this.callbackMethodForUpdatePassRequestFormData.bind(this));
    }
  }
  callbackMethodForUpdatePassRequestFormData(response) {
    if (response && response.Success) {
      this.notificationsService.toastNotify('success', 'Success Message', 'Pass request Updated successfully');
      this.trackDetails(
        this.updateActionTrack,
        this.passRequestForFormData,
        "UpdateAction",
        false
      );
      this.router.navigate(['pob/pass-request-overview']);
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Something went wrong!');
    }
    this.baseService.showRootLoader = false;
  }


  trackDetails(OldValue, NewValue, action, isNew) {
    const columnNames = Object.getOwnPropertyNames(NewValue);
      columnNames.forEach(element => {
        if (OldValue.length === 0) {
          this.retVal = false;
          // OldValue = null;
        }else if (element === "PrerequisiteDocuments") {
          const userLoginActivity = new UserLogInActivity();
          userLoginActivity.FieldName = element;
  
          //for (var i = 0; i < NewValue[element].length; i++) {
            if (OldValue.length !== 0) {
              OldValue[element].forEach(element => {
                //this.url = element.name;
                if(element.HSECheckDocuments!=null){
                  element.HSECheckDocuments.forEach(element => {
                    this.url =element.Name;
                });
              
              userLoginActivity.OldValue += this.url + ",";
            } else {
              userLoginActivity.OldValue = null;
            }
          });
        }
        //}
          // for (var i = 0; i < NewValue[element].length; i++) {
          //   NewValue[element].forEach(element => {
          //     this.url1 = element.name;
          //   });
          //   userLoginActivity.NewValue += this.url1;
          // }
          NewValue[element].forEach(element => {
            //this.url = element.name;
            if(element.HSECheckDocuments!=null){
              element.HSECheckDocuments.forEach(element => {
                this.url1 =element.Name;
            });
          
          userLoginActivity.NewValue += this.url1 + ",";
        } 
      });
          this.userActivityList.push(userLoginActivity);
        
        } else {
          this.retVal = this.commonService.isDataEqual(
            OldValue[element],
            NewValue[element]
          );
        }
      if (this.retVal === false) {
        switch (action) {
          case "UpdateAction":
          if (element === "ApprovalStatus") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "ApprovingAuthority") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "ApprovingAuthorityId") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "BlockedRemarks") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "CompanyId") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "CompanyName") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "CreatedDate") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "DepartmentName") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "Designation") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "DesignationText") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "DocumentStatus") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "EmailId") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "ExpiryDate") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "FullName") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "Id") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "JobDescription") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "PassTypeName") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "ModifiedDate") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "PassRequestFromDate") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "PassRequestToDate") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "ValidityDate") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }else if (element === "QrCode") {
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          }
          
          

          
        }

      }

    });
    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        this.passrequestId,
        new Date(),
        "POB",
        this.loggedInUserJSON.UserId,
        this.userActivityList
      );
    }
  }
  blockedStatus(priorityToFormat) {
    let strPriority = null;
    switch (priorityToFormat) {
      case false:
        strPriority = "false";
        break;
      case true:
        strPriority = "true";
        break;
        
    }
    return strPriority;
  }

  callbackMethodForSavePassRequestFormData(response) {
    if (response && response.Success) {
      this.notificationsService.toastNotify('success', 'Success Message', 'Pass request submitted successfully');
      this.router.navigate(['pob/pass-request-overview']);
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Something went wrong!');
    }
    this.baseService.showRootLoader = false;
  }
  // Shows error message when service is not available ( WebAPIs are not in running mode)
  serviceError() {
    this.hseErrorHandler.handleError('Service (WebAPI) is not available or not in running mode');
  }
  checkValidation() {
    const email = this.passRequestForFormData.EmailId;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.validate = true;
    this.isIncidentReportErrorMsg = false;
    this.errorMsgForRangeDate = false;
    if (!this.passRequestForFormData.FullName) {
      this.isPersonNameMsg = true;
      this.validate = false;
    } else {
      this.isPersonNameMsg = false;
    }
    if (!this.passRequestForFormData.CompanyName) {
      this.isPersonCompanyMsg = true;
      this.validate = false;
    } else {
      this.isPersonCompanyMsg = false;
    }

if (!email || !emailRegex.test(email)) {

  this.validate = false;
}
else{
  this.validate = true;
}
    if (!this.passRequestForFormData.Id) {
      this.isIdMsg = true;
      this.validate = false;
    } else {
      this.isIdMsg = false;
    }
    if (!this.passRequestForFormData.JobDescription && this.passTypeRowNameValue === 'Contractor') {
      this.isJobDescpMsg = true;
      this.validate = false;
    } else {
      this.isJobDescpMsg = false;
    }
    if (!this.passRequestForFormData.Designation && this.passTypeRowNameValue === 'Contractor') {
      this.isDesignationMsg = true;
      this.validate = false;
    } else {
      this.isDesignationMsg = false;
    }
    if (!this.passRequestForFormData.DepartmentName && this.passTypeRowNameValue === 'Staff') {
      this.isDepartmentMsg = true;
      this.validate = false;
    } else {
      this.isDepartmentMsg = false;
    }
    if (!this.passRequestForFormData.PassRequestFromDate && this.passTypeRowNameValue === 'Contractor') {
      this.isFromDateMsg = true;
      this.validate = false;
    } else {
      this.isFromDateMsg = false;
    }
    // if (!this.passRequestForFormData.ValidityDate && this.passTypeRowNameValue === 'Contractor') {
    // 	this.isValidityDateMsg = true;
    // 	this.validate = false;
    // } else {
    // 	this.isValidityDateMsg = false;
    // }
    if (!this.passRequestForFormData.BlockedRemarks && this.isBlocked === 'true') {
      this.isBlockedRemarks = true;
      this.validate = false;
    } else {
      this.isBlockedRemarks = false;
    }
    if (!this.passRequestForFormData.PassRequestToDate && this.passTypeRowNameValue === 'Contractor') {
      this.isToDateMsg = true;
      this.validate = false;
    } else {
      this.isToDateMsg = false;
    }
    this.prerequisite.forEach(element => {
      if (element.TypeOfData === 'Document' || element.TypeOfData === 'Image' ) {
        if (element.HSECheckDocuments.length === 0 && element.Documents.length === 0) {
          element.IsDocumnentErrorMsg = true;
          this.validate = false;
        } else {
          element.IsDocumnentErrorMsg = false;
        }
      }
    });
    if (this.passRequestForFormData.PassRequestFromDate.getTime() > this.passRequestForFormData.PassRequestToDate.getTime()) {
      this.errorMsgForRangeDate = true;
      this.validate = false;
    } else {
      this.errorMsgForRangeDate = false;
    }
    if (!this.validate) {
      this.notificationsService.toastNotify('error', 'Error Message', 'Please fill all mandatory fields!');
    }
    if (!this.prerequisite.length) {
      this.notificationsService.toastNotify('error', 'Error Message', 'Only Configured Documents are saved.');
    }
  }
  getHSEDocument() {
    const apiRequest = {
      Model: {}
    };
    this.masterscreenService.getPrerequisiteDetails(apiRequest, this.callbackMethodForGetPrerequisiteDetails.bind(this));
  }
  /**
   * Callback method of get location details and save data into variable.
   * @param response - response of request.
   */
  callbackMethodForGetPrerequisiteDetails(response) {
    this.prerequisiteDetailsResponse = response;
  }

  getHSECheckDocuments() {
    const apiRequest = {
      Model: {}
    };
    this.pobServices.getHSECheckDocuments(apiRequest, this.callbackMethodForGetHSECheckDocuments.bind(this));
  }
  /**
   * Callback method of get location details and save data into variable.
   * @param response - response of request.
   */
  callbackMethodForGetHSECheckDocuments(response) {
    if (response.Success) {
      this.statusDetails = []
      this.StatusForHSEDocumentResponse = response.Result;
      const locationDetails = response.Result;
      locationDetails.forEach((location) => {
        this.statusDetails.push(
          {
            'label': location.Name,
            'value': location.POBHSEDocumentStatusId
          }
        );
      });
      this.StatusForHSEDocumentResponse = response.Result;
    }
  }
  retriveListOfPrerequisiteConfigurationMapping(data) {
    this.onPageLoad = false;
    //this.CompanyId = data.CompanyId;
    this.UnitName = data.UnitName;
    this.LocationId = data.LocationId;
    this.UnitId = data.UnitId;
    this.passTypeRowIdValue = data.passTypeRowIdValue;
    this.passRequestForFormData.PassRequestId = data.tempPassId;
    this.preRequisitesConfiguration.PreRequisiteIds = [];
    this.prerequisite = [];
    this.preRequisitesConfiguration.UnitId = this.UnitId;
    this.preRequisitesConfiguration.LocationId = this.LocationId;
    this.preRequisitesConfiguration.PassTypeId = this.passTypeRowIdValue;
    const apiRequest = {
      Model: this.preRequisitesConfiguration
    };
    if (this.UnitId != null && this.LocationId != null && this.passTypeRowIdValue != null) {
      this.masterscreenService.RetriveListOfPrerequisiteConfigurationMapping(apiRequest, this.callbackRetriveListOfPrerequisiteConfigurationMapping.bind(this));
    }
  }
  callbackRetriveListOfPrerequisiteConfigurationMapping(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      if (response.Result.length > 0) {
        this.PrerequisiteIds = response.Result;
        this.prerequisite = [];
        this.PrerequisiteIds.forEach((PrerequisiteId) => {
          this.prerequisiteDetailsResponse.forEach(prerequisiteDetail => {
            if (prerequisiteDetail.PreRequisiteDetailsId === PrerequisiteId.PreRequisiteDetailsId) {
              let tempDocumentData = new Document();
              tempDocumentData.PassRequestId = 1;
              tempDocumentData.Name = prerequisiteDetail.PrerequisiteName,
                tempDocumentData.PreRequisiteDetailsId = prerequisiteDetail.PreRequisiteDetailsId,
                tempDocumentData.HSECheckDocuments = [];
              tempDocumentData.POBHSEDocumentStatusName = '';
              tempDocumentData.ExpiryDate = new Date();
              tempDocumentData.HseRemarks = '';
              tempDocumentData.IsExpiryNeeded = prerequisiteDetail.IsExpireyDateNeeded;
              tempDocumentData.TypeOfData = prerequisiteDetail.TypeOfData;
              tempDocumentData.POBHSEDocumentStatusId = 5;
              tempDocumentData.Value = '';
              this.prerequisitesDate.push(tempDocumentData.ExpiryDate);
              this.prerequisite.push(tempDocumentData);
              var minimumDate = new Date(Math.min.apply(null, this.prerequisitesDate));
              this.passRequestForFormData.ExpiryDate = minimumDate ? minimumDate : new Date();
              this.prerequisitesDate = [];
            }
          });
        });
      }
      if (this.passTypeRowNameValue === 'Staff') {
        this.passRequestForFormData.CompanyName = 'ARA';
      }
    }
    this.gstatus = true;
  }

  getPrerequisiteConfiguration() {
    const apiRequest = {
      Model: {}
    };
    this.pobServices.getPrerequisiteConfiguration(apiRequest, this.callbackMethodForGetPrerequisiteConfiguration.bind(this));
  }
  /**
   * Callback method of get location details and save data into variable.
   * @param response - response of request.
   */
  callbackMethodForGetPrerequisiteConfiguration(response) {
    if (response.Success) {
      this.preReqConfigurationRequest = response.Result;
    }
  }

  getUserTypes() {
    this.observationService.getUserTypes(this.callbackMethodForgetUserTypes.bind(this));
  }
  callbackMethodForgetUserTypes(response) {
    if (response.Error != null) {
      this.hseErrorHandler.handleError(response.Error);
    }

    if (response.Success) {
      this.userTypes = response.Result;
    }
  }

  // Reset field value
  resetValue() {
    this.passRequestForData = new MasterRequest();
    this.passRequestForFormData = new Request();
    this.passRequestForDocument = new Document();
    this.alertType = null;
    this.errorDetails = null;
    this.successDetails = null;
    this.confirmMessage = null;
    this.OnChangeEvent.emit();
  }
  // call when you click on no of msg popup
  onNoClickedForConfirmation() {
    this.confirmMessage = '';
    this.alertType = '';
  }
  getUsersOnSearch(event) {
    if (this.passTypeRowNameValue === "Staff") {
      this.searchTexts.UserTypeId = 1;
    } else {
      this.searchTexts.UserTypeId = 2;
    }
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.pobService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));
  }
  // call back method of employee on search
  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response.Success) {
      const filtered: any[] = [];
      for (let index = 0; index < response.Result.length; index++) {
        const user = response.Result[index];
        if (
          user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(user);
        }
      }
      this.userResults = filtered;
    }
  }
  selectActionOwner(event, index: number) {
    if (!event.UserId) {
      this.passRequestForFormData.FullName = '';
      this.passRequestForFormData.EmailId = '';
      this.passRequestForFormData.UserId = 0;//Pritesh
      this.UserId = 0;//Pritesh
    } else {
      this.passRequestForFormData.FullName = event.FullName;
      this.passRequestForFormData.EmailId = event.Email;
      this.passRequestForFormData.DepartmentName = event.UnitName;
      if (event.UnitName && event.UnitId) {
        this.UnitName = event.UnitName;
        this.passRequestForFormData.UnitId = event.UnitId;
      }
      this.passRequestForFormData.Id = event.SecondaryId;
      this.passRequestForFormData.UserId = event.UserId;//Pritesh
      this.UserId = event.UserId;//Pritesh
    }
  }

  getDownListOfUser() {
    this.approvingAuthorityUserData.CurrentSelectedPassTypeName = this.passTypeRowNameValue;
    this.approvingAuthorityUserData.CurrentSelectedUnitId = this.loggedInUserJSON.CompanyId;
    const apiRequest = {
      Model: this.approvingAuthorityUserData
    };
    this.pobServices.getDownListOfUser(apiRequest, this.callbackMethodForGetDownListOfUser.bind(this));
  }

  callbackMethodForGetDownListOfUser(response) {

  }

  saveAndContinuePassRequest() {
    this.checkValidation();
    if (this.validate) {
      this.passRequestForData.PassTypeId = this.passTypeRowIdValue;
      this.passRequestForFormData.PassTypeName = this.passTypeRowNameValue;
      this.passRequestForFormData.ApprovingAuthorityId = this.passRequestForFormData.ApprovingAuthorityId;
      this.passRequestForFormData.PrerequisiteDocuments = this.prerequisite;
      if (this.isBlocked === 'true') {
        this.passRequestForFormData.Blocked = true;
      } else {
        this.passRequestForFormData.Blocked = false;
      }
      this.passRequestForFormData.PassRequestFromDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestFromDate);
      this.passRequestForFormData.PassRequestToDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestToDate);
      this.passRequestForFormData.UnitId = this.UnitId;
      this.passRequestForFormData.LocationId = this.LocationId;
      this.passRequestForFormData.CompanyId = this.CompanyId;
      this.passRequestForFormData.PassTypeId = this.passTypeRowIdValue;
      this.passRequestForFormData.ContractId = this.ContractId;
      this.SaveAndContinueResponse.push(this.passRequestForFormData);
      this.isValidData = true;
      this.baseService.closePopUp(event);
      this.resetValue();
    }
    else {
      this.isValidData = false;
    }
  }

  getPassRequestByPassrequestId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        PassRequestId: this.passrequestId
      }
    };
    this.pobServices.getPassRequestDetailsByPassRequestId(apiRequest, this.callbackMethodForgetPassRequestDetailsByPassRequestId.bind(this));
  }
  callbackMethodForgetPassRequestDetailsByPassRequestId(response) {
    this.baseService.showRootLoader = false;
    if (response.Result) {
    //   if (this.loggedInUserJSON.UserTypes.UserType ===
    //     ObservationConstantsService.RequestFor.Contractor && response.Result.RequestInfo.CreatedBy != this.loggedInUserJSON.UserId
    //  ) {
    //    this.notificationsService.toastNotify(
    //      "error",
    //      "Warning Message",
    //      "This POB not raised by you, you don't have permission to view this record...!"
    //    );  
    //    this.router.navigate(["pob/pass-request-overview"]);
    //    return ;
    //  }
      this.passRequestForData = response.Result;
      
      this.passRequestForFormData = response.Result.RequestInfo;
      this.passId = this.passRequestForFormData.PassRequestId;
      this.isActive = this.passRequestForFormData.PassStatusName == "Pending For Approval" ? true : false;
      this.passRequestForFormData.PassRequestFromDate = new Date(moment(moment.utc(response.Result.RequestInfo.PassRequestFromDate).local()).format('MMM D, YYYY LT'));
      this.passRequestForFormData.PassRequestToDate = new Date(moment(moment.utc(response.Result.RequestInfo.PassRequestToDate).local()).format('MMM D, YYYY LT'));
      this.passRequestForFormData.ExpiryDate = new Date(moment(moment.utc(response.Result.RequestInfo.ExpiryDate).local()).format('MMM D, YYYY LT'));
      this.passRequestForFormData.ValidityDate = response.Result.RequestInfo.ValidityDate ? new Date(moment(moment.utc(response.Result.RequestInfo.ValidityDate).local()).format('MMM D, YYYY LT')) : new Date();
      this.prerequisite = response.Result.RequestInfo.PrerequisiteDocuments;
      this.ref.detectChanges();
      this.prerequisite.forEach(element => {
        element.ExpiryDate = new Date(moment(moment.utc(element.ExpiryDate).local()).format('MMM D, YYYY LT'));
        this.ref.detectChanges();
        element.Documents = element.HSECheckDocuments;
        element.HSECheckDocuments = element.HSECheckDocuments;
      });
      this.prerequisite = response.Result.RequestInfo.PrerequisiteDocuments;
      this.CompanyName = this.passRequestForData.CompanyName;
      this.LocationName = this.passRequestForData.LocationName;
      this.isInactiveLocation = this.passRequestForData.InActive;
      this.passTypeRowIdValue = this.passRequestForData.PassTypeId;
      this.passTypeRowNameValue = this.passRequestForData.PassTypeName;
      this.passRequestLogInfo = this.passRequestForFormData.PassRequestLogInfo;
      this.isBlocked = this.passRequestForFormData.Blocked.toString();
      this.LocationId = this.passRequestForData.MasterLocationId;
      this.CompanyId = this.passRequestForData.MasterCompanyId;
      this.UnitId = this.passRequestForData.MasterUnitId;
      this.UnitName = this.passRequestForData.UnitName;
      this.passTypeRowIdValue = this.passRequestForData.PassTypeId;
      
      this.getApprovals();
      this.pobStatus.forEach(status => {
        if (status.StatusId === this.passRequestForFormData.PassRequestStatusId) {
          if (status.StatusName === 'Granted') {
            this.isShowAccept = false;
            this.passRequestForFormData.PassRequestStatus = 'Granted';
          }
        }
      });
      this.passIds = this.pobServices.getAllPassRequests();
      if(this.passIds == null){
        this.isNext = false;
        this.isPrevious = false;
      }
	    else
      {      
      let currentIndex: number = 0;
      this.passIds.forEach((element, index) => {
        if (element === this.passrequestId) {
          currentIndex = index;
        }
      });
      if (currentIndex === 0) {
        this.isPrevious = false;
      }
      if (currentIndex === this.passIds.length - 1) {
        this.isNext = false;
      }
     }
    }
    this.getPermissionDetails();
  }
  onYesClickedSuccess() {
    this.alertType = null;
    this.successDetails = null;
    this.baseService.closePopUp(event);
    this.router.navigate(['pob/pass-request-overview']);
  }
  checkValidatioinForApproval(status) {
    this.passRequestStatus = status;
    this.validateApproval = true;
    if (this.passRequestStatus === 'Rejected') {
      this.showErrormsg = true;
      this.validateApproval = false;
    }
    if (this.validateApproval === true) {
      this.contractHolderStatus()
    }
  }
  contractHolderStatus() {
    this.baseService.showRootLoader = true;
    this.contractHolderStatusData.RaisedBy = this.loggedInUserJSON.UserId;
    this.contractHolderStatusData.ContractorOrHseStatus = this.passRequestStatus;
    this.contractHolderStatusData.PassRequestId = this.passrequestId;
    const apiRequest = {
      Model: this.contractHolderStatusData,
    };
    this.pobServices.contractHolderStatus(apiRequest, this.callbackMethodForContractHolderStatus.bind(this));
  }
  callbackMethodForContractHolderStatus(response) {
    if (response && response.Success) {
      this.notificationsService.toastNotify('success', 'Success Message', this.passRequestStatus === 'Approved' ? 'Pass Granted Successfully' : 'Pass Rejected Successfully');
      this.router.navigate(['pob/pass-request-overview']);
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Something Went wrong.');
    }
    this.baseService.showRootLoader = false;
  }

  printDiv() {
    this.downloadPrintDialog = true;
    // var left = (screen.width - 900) / 2;
    // var top = (screen.height - 550) / 4;
    // var printContents = window.open('', 'Print Pass', 'height=550,width=900,align=center,top=' + top + ', left=' + left);
    // printContents.document.write('<html><body>');
    // printContents.document.write(document.getElementById('printableContent').innerHTML);
    // printContents.document.write('</body></html>');
    // printContents.document.close();
    // setTimeout(() => printContents.print(), 1000);
  }

  setDates(document) {
    this.prerequisitesDate = [];
    this.prerequisite.forEach(element => {
      if (element.IsExpiryNeeded) {
        this.prerequisitesDate.push(element.ExpiryDate);
      }
    });

    var minimumDate = new Date(Math.min.apply(null, this.prerequisitesDate));
    if (minimumDate < this.passRequestForFormData.PassRequestToDate) {
      this.passRequestForFormData.PassRequestToDate = new Date(minimumDate);
      this.maxPassDate = new Date(minimumDate);
    } else {
      this.maxPassDate = new Date(minimumDate);
    }
  }
  adjustForTimezone(date: Date): Date {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date
  }
  getPassRequestData() {
    const apiRequest = {
      Model: {
        EmailId: this.passRequestForFormData.EmailId
      }
    };
    this.pobServices.getPassRequestDetailsByEmailId(apiRequest, this.callbackMethodForgetPassRequestDetailsByEmailId.bind(this));
  }
  callbackMethodForgetPassRequestDetailsByEmailId(response) {
    this.baseService.showRootLoader = false;
    if (response.Result) {
      response.Result.RequestInfo.PrerequisiteDocuments.forEach(element => {
        element.ExpiryDate = new Date(moment(moment.utc(element.ExpiryDate).local()).format('MMM D, YYYY LT'));
        this.ref.detectChanges();
        element.HSECheckDocuments = element.HSECheckDocuments;
        element.POBHSEDocumentStatusId = 5;
        element.PassRequestId = 0;
        if (this.prerequisite.length > 0) {
          const tempPre = this.prerequisite;
          let oldPre: Document[] = [];
          let index = 0
          do {
            for (index = 0; index < tempPre.length; index++) {
              if (tempPre[index].PreRequisiteDetailsId === element.PreRequisiteDetailsId) {
                oldPre.push(element);
                tempPre.splice(index, 1);
                break;
              }
            }
          } while (index < this.prerequisite.length)
          oldPre.forEach(old => {
            tempPre.push(old)
          });
          this.prerequisite = tempPre;
        }
      });
    }
  }
  onYesClickedForConfirmation() { }
  onPreviousClick() {
    this.passIndex = -1;
    this.isNext = true;
    this.disablePOB = false;
    this.passIds = this.pobServices.getAllPassRequests();
   if(this.passIds!=null && this.passIds.length>0){
    this.passIds.forEach((element, index) => {
      if (element === this.passrequestId && (index - 1) != null) {
        this.passIndex = index - 1;
        if (this.passIndex <= 0) {
          this.isPrevious = false;
        }
        else {
          this.isPrevious = true;
        }
        return;
      }
    });
  }
    if (this.passIndex > -1) {
      this.passrequestId = this.passIds[this.passIndex];
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          PassRequestId: this.passrequestId
        }
      };
      this.pobServices.getPassRequestDetailsByPassRequestId(apiRequest, this.callbackMethodForgetPassRequestDetailsByPassRequestId.bind(this));
      this.router.navigate(['pob/view-pass-request/' + this.passrequestId]);
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.passIndex = -1;
    this.disablePOB = false;
    this.passIds = this.pobServices.getAllPassRequests();
    if(this.passIds!=null && this.passIds.length>0)
   {

    this.passIds.forEach((element, index) => {
      if (element === this.passrequestId && (index + 1) != null) {
        this.passIndex = index + 1;
        if (this.passIndex + 1 == this.passIds.length) {
          this.isNext = false;
        }
        else {
          this.isNext = true;
        }
        return;
      }
    });
  }
    if (this.passIndex > -1) {
      this.passrequestId = this.passIds[this.passIndex];
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          PassRequestId: this.passrequestId
        }
      };
      this.pobServices.getPassRequestDetailsByPassRequestId(apiRequest, this.callbackMethodForgetPassRequestDetailsByPassRequestId.bind(this));
      this.router.navigate(['pob/view-pass-request/' + this.passrequestId]);
    }
  }
  downloadPDF() {
    this.notificationsService.toastNotify('info', 'Information Message', 'Download is in Progress!');
    const apiRequest = {
      Model: {
        ProcessName: "POB",
        SourceId: this.passId,
      }
    };
    this.pobServices.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }
  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_pass" + this.passId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  categoryCheckedEmittedValue(value) {
    this.categoryData = value;
  }
  submitSpecificationData() {
    this.specificationDetailsData.RuleId = this.categoryData;
    this.specificationDetailsData.SourceId = this.passrequestId;
    this.specificationDetailsData.ModuleId = this.moduleId;

    const apiRequest = {
      Model: this.specificationDetailsData
    };
    this.observationService.submitSpecificationData(apiRequest, this.callbackMethodForSubmitSpecificationData.bind(this));
  }

  callbackMethodForSubmitSpecificationData(response) {
    if (response.Success) {
    }
  }

  getApprovals() {
    this.baseService.showRootLoader = true;
    const apiRequest = { Model: { PassRequestId: this.passrequestId } }
    this.pobServices.getApprovals(apiRequest, this.callbackmethodforgetapprovals.bind(this));
  }

  callbackmethodforgetapprovals(response) {
    if (response && response.Result && response.Result.length) {
      this.approvaldata = response.Result;
     if(this.approvaldata){
      this.approvaldata.forEach(element => {
        if(element.ApprovalStatus){
          this.allApproved = true;
        }
        else
        this.allApproved = false
        
      });
     }    
      if (this.passTypeRowNameValue === 'Staff') {
        this.SecurityCoordinatorId = this.approvaldata[this.approvaldata.length - 1].ApproverId
      }
      if (this.passTypeRowNameValue === 'Contractor') {
        this.ContractHolderId = this.approvaldata[0].ApproverId
      }        
    }
    this.baseService.showRootLoader = false;  
  }

  setApproval(value, approval) {
    this.currentApproval = approval;
    if (!value && !approval.Remarks) {
      this.notificationsService.toastNotify('error', 'Error Message', "Please provide remarks!");
    } else {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          PassRequestId: this.passrequestId,
          ApprovalName: approval.ApprovalName,
          ApprovalStatus: value,
          ApprovedBy: this.loggedInUserJSON.UserId,
          Remarks: approval.Remarks,
          PassTypeName: this.passTypeRowNameValue
        }
      }
      this.pobServices.setApprovals(apiRequest, this.callbackmethodforsetapprovals.bind(this));
    }
  }

  callbackmethodforsetapprovals(response) {
    if (response) {
      if ((this.passTypeRowNameValue === 'Staff' && this.currentApproval.ApprovalName === 'Security CoOrdinator') || (this.passTypeRowNameValue === 'Contractor' && this.currentApproval.ApprovalName === 'Contract Holder')) {
        this.updatePassRequest();
      } else {
        this.ngOnInit();
      }
    }
    this.baseService.showRootLoader = true;
  }
  getRemarks(text, type) {
    switch (type) {
      case 'Job Description':
        this.passRequestForFormData.JobDescription = text;
        break;
    }
  }

  addPrerequisite(designationValue) {
    let found = this.prerequisite.filter(item => {
      if (item.Name === PersononboardConstantsService.Documents[designationValue])
        return item;
    });

    this.prerequisiteDetailsResponse.forEach(prerequisiteDetail => {
      if (prerequisiteDetail.PrerequisiteName === PersononboardConstantsService.Documents[designationValue] && found.length === 0) {
        let tempDocumentData = new Document();
        tempDocumentData.PassRequestId = this.passId;
        tempDocumentData.Name = prerequisiteDetail.PrerequisiteName;
        tempDocumentData.HSECheckDocuments = [];
        tempDocumentData.POBHSEDocumentStatusName = '';
        tempDocumentData.ExpiryDate = new Date();
        tempDocumentData.HseRemarks = '';
        tempDocumentData.IsExpiryNeeded = prerequisiteDetail.IsExpireyDateNeeded;
        tempDocumentData.TypeOfData = prerequisiteDetail.TypeOfData;
        tempDocumentData.POBHSEDocumentStatusId = 5;
        tempDocumentData.Value = '';
        this.prerequisite.push(tempDocumentData);
      }
    });
    Object.entries(PersononboardConstantsService.Documents).forEach((key, value) => {
      if (designationValue !== key[0]) {
        let i = -1;
        for (let index = 0; index < this.prerequisite.length; index++) {
          const element = this.prerequisite[index];
          if (element.Name === PersononboardConstantsService.Documents[key[0]]) {
            i = index;
          }
        }
        if (i > -1)
          this.prerequisite.splice(i, 1);
      }
    });
  }

  downloadPass() {
    saveAs(this.passRequestForFormData.PrintPass, this.passRequestForFormData.PassId + ".jpg");
  }
  
  getOutput(event) {
    if (event) {
     // this.ngOnInit();
     this.router.navigate(['pob/pass-request-overview']);
    }
  }

  renewRequest() {
    const apiRequest = {
      Model: {
        PassId: this.passId,
        PassRequestToDate: this.adjustForTimezone(this.passRequestForFormData.PassRequestToDate)
      }
    }
    this.pobServices.renewPass(apiRequest, this.callbackMethodForRenewPass.bind(this));
  }

  callbackMethodForRenewPass(response) {
    if (response.Success) {
      this.notificationsService.toastNotify('success', 'Success Message', "Pass has been renewed!");
      this.getPassRequestByPassrequestId();
    }
  }

  recreatePrintPass() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        PassId: this.passId
      }
    }
    this.pobServices.recreatePrintPass(apiRequest, this.callbackMethodForRecreatePrintPass.bind(this));
  }

  callbackMethodForRecreatePrintPass(response) {
    if (response.Success) {
      this.notificationsService.toastNotify('success', 'Success Message', "Pass has been recreated!");
      this.getPassRequestByPassrequestId();
    }
    this.baseService.showRootLoader = false;
  }

  saveAsDraft() {
    this.baseService.closePopup = false;
    this.checkValidation();
    if (this.validate) {
      this.baseService.showRootLoader = true;
      this.onsubmitEvent.emit('data');
      this.passRequestForData.MasterCompanyId = this.CompanyId;
      this.passRequestForData.MasterUnitId = this.UnitId;
      this.passRequestForData.MasterLocationId = this.LocationId;
      this.preReqConfigurationRequest.forEach(element => {
        if (element.UnitId === this.passRequestForData.MasterUnitId && element.LocationId === this.passRequestForData.MasterLocationId && element.PassTypeId === this.passRequestForData.PassTypeId) {
          this.passRequestForData.PreRequisiteConfigurationId = element.PreRequisiteConfigurationId;
        }
      });
      this.passRequestForFormData.PassTypeName = this.passTypeRowNameValue;
      this.passRequestForData.RaisedBy = this.loggedInUserJSON.UserId;
      this.passRequestForData.PassRequestId = this.passrequestId;
      this.passRequestForFormData.PrerequisiteDocuments = this.prerequisite;
      if (this.isBlocked === 'true') {
        this.passRequestForFormData.Blocked = true;
      } else {
        this.passRequestForFormData.Blocked = false;
      }
      this.passRequestForFormData.PassRequestFromDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestFromDate);
      this.passRequestForFormData.PassRequestToDate = this.adjustForTimezone(this.passRequestForFormData.PassRequestToDate);
      this.passRequestForFormData.ExpiryDate = this.adjustForTimezone(this.passRequestForFormData.ExpiryDate);
      this.SaveAndContinueResponse.push(this.passRequestForFormData);
      this.passRequestForData.Requests = this.SaveAndContinueResponse;
      this.passRequestForData.UnitId = this.UnitId;
      this.passRequestForData.CompanyId = this.CompanyId;
      this.passRequestForData.LocationId = this.LocationId;
      this.passRequestForData.PassTypeId = this.passTypeRowIdValue;
      this.passRequestForData.IsDraft=true;
      if (this.categoryData && this.categoryData.length > 0) {
        this.submitSpecificationData();
      }
      const apiRequest = {
        Model: this.passRequestForData
      };
      this.pobServices.UpdatePassRequest(apiRequest, this.callbackMethodForUpdatePassRequestFormData.bind(this));
    }
  }

   //BOC Pritesh
   ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "POB";
    this.ReportRecordId = this.passId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh

}

export class StatusForHSEDocument {
  POBHSEDocumentStatusId: number;
  Name: string;
}
